import enLocale from 'element-ui/lib/locale/lang/en'
import elLocale from 'element-ui/lib/locale/lang/el'

export default {
  en: {
    language: 'Language',
    greek: 'Greek',
    english: 'English',
    greek_dropdown: 'Gr',
    english_dropdown: 'En',
    myapps_warning: `If you have existing applications you will see the last one submitted and you 
                  will be able to select the rest of your applications from the top menu 'My applications'`,
    new_app_warning: `ATTENTION select new application ONLY if you do not want to continue working
                  with the following applications that you have already submitted!`,
    total_num_of_apps_are:
      'ATTENTION the total number of your applications which can be viewed from the top navigation menu are',
    I_confirm:
      'I hereby confirm that I have been informed about the following and I agree:',
    I_declare: 'I responsibly declare that:',
    I_confirmA:
      'a. The application has the affirmation of <strong>  responsible declaration of the article 8 of Law 2599/1986 (FEK A 75) </strong> concerning the facts declared and submitted with the accompanying documents.  Possible <strong>discrepancy of the application facts</strong> may lead to <strong>legal and administrative penalties</strong>.',
    I_confirmB:
      'b. According to paragraph 2b pf article 1 of law 4250/2014 DOATAP has the responsibility to administer sampling control regarding documents submitted.  If during this inspection it is found that <strong>tampered copies</strong> are submitted, the administrative act is <strong>withdrawn instantly</strong>. ',
    I_confirmC:
      'The user has the right to submit <strong>up to 5 active applications</strong> to DOATAP.  If an application is <strong>not submitted within 6 months</strong> from the date of its creation, it is <strong>automatically deleted</strong> from the system.',
    I_confirmD: 'The submitted certificates and documents are genuine',
    I_confirmE: 'I have',
    I_confirmF: 'I have not submitted another application for the recognition of title of studies  at DOATAP / DIKATSA',
    I_confirm_gdpr: 'Please read carefully and consent to the ',
    consent_gdpr: 'Personal Data Protection Declaration - Explicit Consent of the Data Subject΄s Consent to the Processing of Personal Data',
    termsandcons: 'Terms and Conditions of E-DOATAP in detail.',
    hint_app_type: 'Selection of application type for recognition',
    hint_levelof_studies: 'Selection of level of studies for recognition',
    hint_reappraisal:'Selection of application to be reevaluated',
    hint_parity:
      'Choose academic equivalence with congruence if you apply for association with a 5year old program of studies.',
    hint_parity_with:
      'Selection of the field of higher education for equivalence / equivalence and congruence',
    hint_parity2:
      'Equivalence: Recognition of field of study (university or technological) regarding the title in examination.<br>Congruence: Association of the title in examination with a certain program of study of a Hellenic university or technological institution. ',
    hint_consideration:
      'Select academic equivalence to a 5-year degree with co-submission of a 2nd cycle degree ONLY if all of the following hold: <br>(a) you are requesting the academic equivalence to a 5-year Greek degree / diploma (level 7 of the European and National Framework of Qualifications),<br>(b) the study program of your 1st cycle degree (bachelor) did NOT require a thesis, and<br>(c) you accept to co-submit a 2nd cycle degree (master degree). <br>Caution: if a 2nd cycle degree is co-submitted with the 1st cycle degree then the 2nd cycle degree CANNOT BE RECOGNIZED SEPARATELY.',
    hint_con: 'You have chosen to submit:',
    hint_typeof_studies:
      'Conventional: study requires the physical presence of the tutee at the education premises.<br>Distance:  the tutee is distant from the instructor and the education process is implemented using current technological methods.',
    hint_aeitei:
      'Choice of field of higher education for equivalence/equivalence and congruence',
    hint_regular_partial:
      'Regular: mandatory monitoring and participation of classes on the basis of complete studies.<br>Partial: mandatory monitoring and participation of classes on the basis of part-time studies prolonging the duration of studies.',
    hint_partial_gr:
      'If part of the study took place in Hellas, the city and the institution where the teaching took place must be declared.',
    hint_other_country:
      'Select “other” to insert a university’s country which is not listed.  It could cause delays in the process of recognition',
    hint_other_university:
      'Select “other” to insert a university which is not listed.  It could cause delays in the process of recognition',
    hint_title: ' Insert the title of studies as depicted in the certificate.',
    hint_credits:
      'Credit units referring to the studies title. Any transferred credit units (from other institutions or study programs) are declared in the following option. If the degree does not require credit units, fill the value 0.',
    hint_reg_date:
      'Registration date to the institution of the acquired degree.',
    hint_grad_date:
      'Graduation date from the institution of the acquired degree. ',
    hint_duration: 'Anticipated duration of the relevant program of studies.',
    hint_more_unis:
      'If the studies were carried out in more the one institutions or study programs, they must be indicated, also stating the credit units transferred from them.',
    hint_correspondence_uni:
      'Selection of the program of studies of Hellenic university for congruence of the title in examination.',
    label_attachment: 'Select Documentation',
    label_attachment2: 'and related pdf file',
    hint_attachment:
      'Select ONE pdf file up to 13Mb in size (If it is larger, split it into smaller pdf files and upload them as "OTHER DOCUMENT" with a comment next to it)',
    hint_mandatoryfile: 'Mandatory Document',
    hint_mandatoryfile2: 'Mandatory document in certain cases',
    label_info: 'Information',
    personal_data: 'Personal Information',
    wrong_credentials: 'Wrong username or password',
    filesize:
      'You can upload a file up to 12Mb. For bigger files split to smaller ones and upload them as "OTHER DOCUMENT" with a relevant note',
    upload_fail: 'File upload failed',
    fill_in_personal_data_with_caps:
      'Please fill-in personal information with capital letters',
    title_study: 'Title of Study',
    fill_in_information_title_of_study:
      'Please fill in the required information using capital letters',
    fill_in_information_title_assesed:
      'Please fill in the information about the title you want to jointly be assessed ',
    fill_in_all_fields:
      'Please fill-in all required fields and confirm that you are informed about eDoatap system',
    // overdue_warning: 'Your reappraisal application is overdue. According to law 3328/2005 (article 13), an applicant whose application for title of studies recognition is rejected may apply for a reappraisal within 1 year time, referring to the reason of reappraisal application and submitting new documents and an administration fee (225€). An overdue reappraisal application is judged by plenary board in order to be accepted or not. As long as it is rejected, the fee is returned reduced by the amount of 20€. Are you sure you want to proceed?',
    overdue_warning: 'The request for reevaluation of decision is overdue. According to article 313 of Law 4957/2022, a citizen whose request for recognition of a qualification has been rejected, is entitled to submit, within sixty (60) days of receiving the rejection, a request for reevaluation of the desicion, stating the reasons for the request for reevaluation and providing new information as well as the relevant fee of 150 euros. For an overdue application for reevaluation of a desicion, the fee is refunded upon request. Are you sure you want to proceed with submission?',
    overdue_warning_final: 'The application for reevaluation of desicion is overdue. According to article 313 of Law 4957/2022, a citizen whose request for recognition of a qualification has been rejected, is entitled to submit, within sixty (60) days of receiving the rejection, a request for reevaluation of the desicion, stating the reasons for the for the request for reevaluation and providing new information as well as the relevant fee of 150 euros. For an overdue application for reevaluation of a desicion, the fee is refunded upon request. Furthermore, your application will be finalized and you will no longer have the right to process it, unless you will be asked to in the context of the pre-checking process. Are you sure you wish to proceed to submission?',
    submit_warning: 'Are you sure you wish to create an application?',
    upload_documents: 'Please upload the required documents',
    process: 'Application Process',
    app_process: 'The process of your application',
    app_status: 'APPLICATION STATUS',
    reappraisal_app: 'APPLICATION FOR DEGREE RECOGNITION',
    post_exam_reapp_app: 'INITIAL REEVALUATION APPLICATION',
    first_reappraisal_app: 'INITIAL APPLICATION FOR REEVALUATION OF DECISION',
    app_ref: 'REFERENCE NUMBER',
    reg_no: 'REGISTRATION NUMBER',
    applicant: 'Applicant',
    waiting: 'Waiting for pre-checking',
    prechecking: 'Pre-checking',
    surname: 'Surname',
    name: 'Name',
    fname: 'Fathers name',
    mname: 'Mothers name',
    gender: 'Gender',
    countryofbirth: 'Country of birth',
    cityofbirth: 'City of birth',
    dateofbirth: 'Date of birth',
    countryofresidence: 'Country of residence',
    homeaddress: 'Home address',
    zip: 'Zip code',
    city: 'City',
    institution: 'Institution',
    region: 'Region of Residence',
    tel: 'Telephone Number',
    mobile: 'Mobile Number',
    email: 'Email',
    afm: 'Tax Registration Number',
    idcard: 'ID Card',
    passport: 'Passport',
    idnumber: 'Number',
    dateofissue: 'Date of Issue',
    depofissue: 'Department of Issue',
    select: 'Select',
    expirationdate: 'Expiration Date',
    countryofissue: 'Country of Issue',
    equivalenceorcorrespondence: 'Academic Equivalence',
    equivalenceorcorrespondence2: 'Academic Equivalence with congruence',
    equivalenceorcorrespondence3: 'Acad. Equivalence',
    equivalenceofdegree: 'Equivalence',
    with: 'with ',
    uni_tei: 'University or Technical Institution',
    only: 'only to ',
    university: 'University',
    tei: 'Τechnical Institution',
    department: 'University Department',
    department2: 'TEI Department',
    titleforrec: 'Title for Recognition',
    studymode: 'Mode of Study',
    conventional: 'Regular mode of study',
    distance: 'Distance Learning',
    fulltime: 'Full Time',
    parttime: 'Part Time',
    select_country2:
      'Please select the country to see the relevant Universities',
    countryofstudy: 'Country of Study',
    titleofstudy: 'Title of Study',
    ects: 'ECTS',
    credits: 'ECTS',
    enroll_date: 'Start date of studies',
    grad_date: 'Date of Graduation',
    study_madein: 'The studies were carried out ',
    duration: 'Duration of Study',
    joint_assess: 'Title recognition',
    coevaluation: 'Co-submission',
    coevaluation_check: 'Έχετε επιλέξει συνυποβολή τίτλου 2ου κύκλου σπουδών',
    select_doctype: 'Select document type',
    select_file: 'Select file',
    hint_more_unis2:
      'Please fill in the additional Universities and their ECTS',
    add_university: 'Add University',
    delete_university: 'Delete University',
    ido: 'Yes',
    docs_instructions: 'Documents and Instructions',
    docs_link: 'Documents',
    prechecker_comment: 'Pre-Checker Comment',
    applicant_comment: 'Applicant Comment',
    about: 'About E-DOATAP System',
    report: 'report any problem',
    temp_save: 'Temporary Save',
    final_save: 'Final Submission',
    submission: 'Submit',
    placeholder: 'Please type your text here',
    retract_app: 'Re-edit Application',
    delete_app: 'Delete Application',
    logout: 'Log out',
    type_of_app: 'Type of Application',
    new_search: 'Search – New Application',
    options: 'Options',
    select_type: 'Select Type',
    view: 'View',
    myApps: 'My Applications',
    newApp: 'New Application',
    applicationType: 'Application Type',
    recognition: 'Degree Recognition',
    reappraisal: 'Application for Reevaluation of decision',
    compensatory: 'Application after compensatory measures',
    grade_correspondence: 'Grade Correspondence',
    level_of_study: 'Level of Study',
    myfinalizedApps: 'Finalized Applications',
    master: '2nd cycle degree',
    bachelor: '1st cycle degree',
    phd: '3rd cycle degree',
    correspondence: 'correspondence',
    equality: 'equality',
    yes: 'Academic equivalence to 5 years degree with co submission of a 2nd cycle degree',
    no: 'Academic equivalence',
    submit: 'Submit',
    force_overdue: 'Force overdue (only in test environment)',
    force_overdue_hint: 'This option is available <b>only</b> in the test environment<br>for the mandatory marking of the application as overdue<br>during the <b>first</b> "Final Submission"',
    overdue_message: 'ΑΤΤΕΝΤΙΟΝ! The application for Reevaluation of decision is overdue',
    app_status1: 'Application Status',
    date: 'Date',
    document: 'Document',
    filename: 'File Name',
    actions: 'Actions',
    user_comment: 'User Comment',
    doatap_comment: 'DOATAP Comment',
    new_app_title: 'Please select the type of your application',
    president: 'President',
    proponent: 'Credential Evaluator',
    executive: 'Executive Committee',
    consultant: 'Evaluator',
    viceA: 'Vice President A',
    viceB: 'Vice President B',
    process_viewer: 'Process Viewer',
    print: 'Print Decision',
    reappraisal_board: 'Special Reevaluation Board',
    academic_director: 'Academic Director',
    completed1:
      'Completed – The application was canceled after applicant’s request',
    completed2: 'Completed',
    registered_app: 'Registered – Under consideration',
    registered_reapp: 'Registered – Under reevaluation',
    registered_post_exam: 'Registered - Pending decision after examinations',
    temp_saved: 'Temporarily Saved – Not finally submitted',
    final_saved: 'Submitted - In Precheckers Queue',
    date_received: 'Date of automated email to applicant for decision receipt',
    date_downloaded: 'Decision Receipt Date',
    date_done: 'Decision Date',
    decision_no: 'Decision Number',
    one_university: 'in one university',
    several_universities: 'in several universities',
    conclusion: 'an application for ',
    conclusion2: ' 1st cycle degree',
    conclusion3: ' academic equivalence of your',
    conclusion4:
      ' with  academic equivalence',
    conclusion5: ' the University or Technical education department',
    conclusion6: ' the University department ONLY',
    conclusion7: ' the Technical education department ONLY',
    conclusion8: ' to a 5-year degree with co-submission of a 2nd cycle degree',
    conclusion9: ' 2nd cycle degree to the Greek master degrees',
    conclusion10: ' with a grade correspondence',
    conclusion11: ' without a grade correspondence',
    conclusion12: ' 3rd cycle degree to the Greek doctorate degrees',
    conclusion13: ' Application for Reevaluation of decision',
    titleTemp0: 'User is filling-in his/her application before submitting it',
    contentTemp0: 'State: In user processing',
    titleTemp1:
      'The application is in precheckers queue in order to be checked upon its details and submitted documents',
    contentTemp1: 'Waiting for data check',
    titleTemp2: 'Expected',
    titleTemp21: 'In process by prechecker ',
    titleTemp22: 'Precheckers process',
    titleTemp2postExam: 'Precheckers process (after Exams)',
    contentTemp2: 'Process by prechecker',
    contentTemp2postExam: 'Process by prechecker (after Exams)',
    titleTemp3: 'Waiting to be launched by the president',
    titleTemp33: 'Process by president',
    titleTemp32: 'Desicion signing',
    titleTemp34:
      'The decision file can be downloaded in the Attachments section',
    contentTemp34: 'Recognition process complete',
    contentTemp35: 'Recognition Act received',
    titleTemp4: 'Result of credential evaluator process',
    titleTemp41: 'Process by credential evaluator',
    titleTemp5: 'Process by executive board',
    titleTemp6: 'Process by evaluator',
    titleTemp7: 'Process by vice president',
    titleTemp9: 'Preparation before assignment to president',
    titleTemp10: 'Decision write up',
    titleTemp11: 'Process by Special Reevaluation Board',
    titleTemp12: 'Process by Academic Director',
    historyTitleDownloaded: 'The decision was received by the applicant',
    historyContentDownloaded: 'Decision received',
    historyTitlePrintDecisionsQueue: 'In queue for preparation of decision',
    historyContentPrintDecisionsQueue: 'In queue for preparation of decision',
    historyTitlePrintDecision: 'Pending decision writing',
    historyContentPrintDecision: 'Pending decision writing',
    with_equivalence: 'with Academic Equivalence',
    without_equivalence: 'with Academic Equivalence',
    with_consideration: 'with co-submission of a masters degree',
    without_consideration: 'without co-submission of a masters degree',
    for: 'for',
    for_app: 'for application',
    informed: 'I am informed',
    consent: 'I consent',
    download: 'Download',
    delete: 'Delete',
    attachments: 'Attachments',
    warning: 'Warning',
    error: 'Error',
    cancel: 'Cancel',
    button_yes: 'Yes',
    //     delete_fail:'Delete could not be done',
    refresh_notallowed:
      'Refresh not allowed because it may lead to data loss! In order to exit the aplication and temporare data to be deleted from your browser please select Log out on rigth top of the screen.',
    msg_forDB:
      'Doatap database contains information about recognition acts from 1998 onwards',
    fill_comment: 'Please fill-in your comment',
    success: 'Success',
    success_delete: 'Deleted successfully',
    fail: 'Failed',
    fail_delete: 'Delete failed',
    //     data_saved:'Data saved successfully',
    submitApp:
      'Your application will be submitted and you will no longer have the right to process it, unless you will be asked to in the context of the pre-checking process. Are you sure you wish to procceed to submission?',
    failed_submit: 'Submission failed!',
    failed_submit2: 'More data required in tabs:',
    failed_submit3: ' Personal Information,',
    failed_submit4: ' Title of Study,',
    failed_submit5: ' Cosubmission of other title,',
    failed_submit6:
      ' Attachments where all required documents must be uploaded ',
    //     msg_finalsave:'Application saved. You will be informed via e-mail about its process which you can track through the tab Application Process',
    protocol_expected: 'Expected after submission',
    //     comment_saved:'Comment submitted',
    fill_in: 'All fields need to be filled in!',
    fill_confirm: 'You must fill in the appropriate fields, check that you have been informed of all the terms above and declare that the documents you will submit are genuine.',
    same_pass_msg: 'Please enter the same password to confirm!',
    session_expire_msg:
      'Your session is about to expire in 1 min. Please select Temporary Save because log in will be needed again for security reasons',
    no_unis_found: 'No universities found for the selected Country',
    correct_approval:
      'Αν επιλέξετε Διόρθωση στοιχείων πρέπει να καταγράψετε τον λόγο υποχρεωτικά!',
    //     approval:'Your approval has been submitted and forwarded to be signed up. You will be informed via e-mail about the processwhich you can also track through the tab Application Process',
    //     approval_fail:'Submission of your approval failed',
    change_pass:
      'If password is changed successfully you will be redirected to log in again with your new password',
    confirm_retract: 'Your application will open for editing again',
    confirm_delete: 'Your application is about to be deleted',
    //     app_deleted:'Application deleted',
    retract_canceled: 'Retracking was canceled',
    delete_canceled: 'Delete cancelled',
    add_info:
      'Additional information is displayed below the graph by clicking on each timeline',
    select_university: 'Select University',
    search: 'Search',
    doc: 'Document',
    comments: 'Comments',
    overall_comment: 'Overall application comment',
    hint_tempsave: 'Temporarily saves application during its creation process',
    hint_finalsave:
      'Completes the application process. No further changes can be made to the application.',
    hint_retract:
      'Retracts your application ONLY while waiting for pre-checking for further editing',
    hint_delete:
      'Deletes your application permanently. Available only before final submission.',
    select_country: 'Select Country',
    select_date: 'Select Date',
    country: 'Country',
    placeholder_act: 'Comments about recognition act (up to 300 characters)',
    fill_in_country: 'Fill-in country',
    fill_in_uni: 'Fill-in your university',
    universities: 'Universities',
    years: 'Years',
    new_university: 'New University',
    greek_uni: 'Greek University',
    foreign_uni: 'University abroad',
    first_bachelor: 'Bachelor at ',
    firstBachelorInfoMsg: 'Please fill in the details of your initial degree (1st cycle degree)',
    dep_uni: 'Department/University',
    rec_act: 'Recognition Act',
    male: 'MALE',
    female: 'FEMALE',
    other_gender: 'OTHER',
    other_option: 'Other',
    other_country: 'Other country',
    finalsave_canceled: 'Final Save cancelled by user',
    draft_approval:
      'Please once you check carefully the recognition act draft, update listed data and click Send. If any correction needed, please fill in your remarks in the appropriate field. If no update is send within 5 days from issue date of the draft, the recognition act will be published as it is.',
    updateData: 'Update',
    correctInfo: 'Correct Data',
    updateInfo: 'Update Data',
    remarks: 'Remarks',
    sendApprove: 'Sends approval along with your comments and remarks.',
    sendApprove2: 'Send updated approval',
    first_download:
      'The date of the first file download is considered as the receipt date of the recognition act. In case you are not able to open the file you should communicate DOATAP within next TEN (10) days.',
    first_download2:
      'The decision receipt date is set when you press the OK button for first time.',
    remaining: 'remaining days to contact DOATAP if there is a problem',
    received: 'You received the recognition act ',
    daysbefore: ' days before',
    attention:
      'ATTENTION, you have selected academic equivalence to a 5-year degree with co- submission of a 2nd cycle degree. This option is possible ONLY if all of the following hold: (a) you are requesting the academic equivalence to a 5-year Greek degree /diploma (level 7 of the European and National Framework of Qualifications), (b) the study program of your 1st cycle degree (bachelor) did NOT require a thesis, and (c) you accept to co-submit a 2nd cycle degree (master degree). Caution: if a 2nd cycle degree is co-submitted with the 1st cycle degree then the 2nd cycle degree CANNOT BE RECOGNIZED SEPARATELY.',
    login: 'Log in to e-Doatap',
    username: 'Username',
    password: 'Password',
    erase: 'Clear',
    changepass: 'Change username and password',
    newusername: 'New Username',
    oldpass: 'Old Password',
    newpass: 'New Password',
    verify: 'Verify new password',
    session:
      'Session will expire in 1 min. Please select Temporary Save because new login will be needed for security reasons.',
    newWord: 'new',
    my_chats: 'My chats',
    notifications: 'Chats-Messages',
    application: 'Application',
    user: 'User',
    send: 'Send',
    finalizedAppsMsg: 'Finalized applications not found in order for you to apply for a reevaluation',
    // PersonalDetails.vue messages
    telephoneRequiredMsg: 'Please insert a telephone number',
    mobileValidationMsg: 'The mobile number must be 10 - 20 digits',
    surnameRequiredMsg: 'The surname may not be null',
    nameRequiredMsg: 'The name may not be null',
    birthDateRequiredMsg: 'Please insert the date of birth',
    fatherNameRequiredMsg: "Father's name may not be null",
    emailRequiredMsg: 'Insert your e-mail',
    emailValidationMsg: 'Please insert a valid e-mail address',
    mobileRequiredMsg: 'Please insert a mobile number',
    numberValidationMsg: 'The number must be 10 to 20 digits',
    cityRequiredMsg: 'Please insert the city',
    zipCodeValidationMsg: 'Please insert the zip code (2-16 digits)',
    addressRequiredMsg: 'Please insert your address',
    birthCountryRequiredMsg: 'Please insert the country of birth',
    residenceCountryRequiredMsg: 'Please insert the country of residence',
    genderRequiredMsg: 'Please insert your gender',
    idNumberRequiredMsg: 'Please insert ID or Passport number',
    issueDateRequiredMsg: 'Please insert the date of issue',
    issueAuthorityRequiredMsg: 'Please insert the department of issue',
    expirationDateRequiredMsg: 'Please insert the expiration date',
    // TitleConsideration.vue messages
    studyCityRequiredMsg: 'Please insert the city of your studies',
    institutionRequiredMsg: 'Please insert the institution of studies',
    studyCountryRequiredMsg: 'Please insert the country of your studies',
    universityRequiredMsg: 'Please insert the university of studies',
    titleRequiredMsg: 'Please insert the title of studies',
    ectsValidationMsg: 'Please insert the ECTS (value must be 1 to 1000)',
    startDateRequiredMsg: 'Please insert the start date of studies',
    graduationDateRequiredMsg: 'Please insert the date of graduation',
    durationRequiredMsg: 'Please insert the duration of studies',
    // Titles.vue messages
    studyCitySelectMsg: 'Please insert the city of your studies',
    institutionSelectMsg: 'Please insert the institution of studies',
    studyCountrySelectMsg: 'Please select the country of your studies',
    studyCountryInsertMsg: 'Please insert the country of your studies',
    universitySelectMsg: 'Please select the university of studies',
    universityInsertMsg: 'Please insert the university of studies',
    titleInsertMsg: 'Please insert the title of studies',
    ectsInsertMsg: 'Please insert the ECTS (value must be 1 to 1000)',
    startDateSelectMsg: 'Please select the start date of studies',
    graduationDateSelectMsg: 'Please select the date of graduation',
    durationSelectMsg: 'Please select the duration of studies',
    departmentSelectMsg: 'Please select a corresponding university department for the recognition of degree',
    fieldRequiredMsg: 'Please fill in the field',
    ...enLocale, // Or use `Object.assign({ message: 'hello' }, enLocale)`
  },
  el: {
    language: 'Γλώσσα',
    greek: 'Ελληνικά',
    english: 'Αγγλικά',
    greek_dropdown: 'Ελ',
    english_dropdown: 'Αγγ',
    myapps_warning: `Αν έχετε αιτήσεις θα δείτε την τελευταία αίτηση σας και θα μπορείτε 
                να επιλέξετε παλαιότερες από το επάνω μενού 'Οι αιτήσεις μου'`,
    new_app_warning: `ΠΡΟΣΟΧΗ επιλέξτε νέα αίτηση ΜΟΝΟ αν δεν δεν θέλετε να 
                  συνεχίσετε να δουλεύετε με μια από τις παρακάτω που έχετε ήδη καταχωρήσει!`,
    total_num_of_apps_are:
      'ΠΡΟΣΟΧΗ το σύνολο των αιτήσεων σας που μπορείτε να δείτε στην πάνω μπάρα πλοήγησης είναι',
    I_confirm: 'Επιβεβαιώνω ότι έχω λάβει γνώση για τα κάτωθι και συμφωνώ:',
    I_declare: 'Δηλώνω υπεύθυνα ότι:',
    I_confirmA:
      'α. Η αίτηση επέχει <strong> θέση υπεύθυνης δήλωσης του άρθρου 8 του ν.1599/1986 (ΦΕΚ Α΄75) </strong> για τα στοιχεία που αναφέρονται σε αυτήν και τα υποβαλλόμενα με αυτήν δικαιολογητικά. Η <strong> ανακρίβεια των στοιχείων </strong> που δηλώνονται στην αίτηση επισύρει τις προβλεπόμενες <strong> ποινικές και διοικητικές κυρώσεις </strong>.',
    I_confirmB:
      'β. Σύμφωνα με την παρ. 2β του άρθρου 1 του Ν. 4250/2014, ο ΔΟΑΤΑΠ υποχρεούται να διενεργεί δειγματοληπτικό έλεγχο επί των αρχείων που υποβάλλονται σε αυτόν. Εάν διαπιστωθεί κατά τον υποχρεωτικό ή άλλο έλεγχο ότι υποβλήθηκαν <strong>αλλοιωμένα φωτοαντίγραφα</strong>, εκτός από τις κυρώσεις που προβλέπονται στην παρ. 6 του άρθρου 22 του ν. 1599/86, η διοικητική ή άλλη πράξη για την έκδοση της οποίας υποβλήθηκαν τα φωτοαντίγραφα αυτά, <strong>ανακαλείται αμέσως</strong>.',
    I_confirmC:
      'γ. Ο χρήστης έχει τη δυνατότητα δημιουργίας <strong>έως πέντε (5) ενεργών αιτήσεων</strong> προς τον ΔΟΑΤΑΠ. Σε περίπτωση που <strong>μια αίτηση δεν υποβληθεί οριστικά σε διάστημα 6 μηνών</strong> από την ημερομηνία δημιουργίας της, αυτή <strong>διαγράφεται αυτόματα</strong> από το σύστημα.',
    I_confirmD: 'Τα υποβληθέντα πιστοποιητικά είναι γνήσια',
    I_confirmE: 'Έχω',
    I_confirmF: 'Δεν έχω υποβάλει άλλη αίτηση για αναγνώριση του κρινόμενου τίτλου σπουδών στον Δ.Ο.Α.Τ.Α.Π./ΔΙ.Κ.Α.Τ.Σ.Α.',
    I_confirm_gdpr: 'Παρακαλούμε διαβάστε προσεκτικά και δηλώστε οτι συναινείτε στην ',
    consent_gdpr: 'Δήλωση Προστασίας Προσωπικών Δεδομένων – Ρητή Συγκατάθεση του Υποκειμένου των Δεδομένων για την Επεξεργασία των Δεδομένων Προσωπικού Χαρακτήρα',
    termsandcons: 'Αναλυτικά όροι και προϋποθέσεις χρήσης του eDoatap.gr',
    hint_app_type: 'Επιλογή τύπου αίτησης προς αναγνώριση.',
    hint_levelof_studies: 'Επιλογή επιπέδου σπουδών προς αναγνώριση',
    hint_reappraisal:'Επιλογή αίτησης για επανεξέταση',
    hint_parity:
      'Επιλέξτε ισοδυναμία με συνεκτίμηση εαν αιτείστε αναγνώριση ακαδημαϊκής ισοδυναμίας με 5ετές αντίστοιχο τίτλο σπουδών.',
    hint_parity_with:
      'Επιλογή τομέα ανώτατης εκπαίδευσης για Ισοτιμία/Ισοτιμία και Αντιστοιχία',
    hint_parity2:
      'Ισοτιμία: Αναγνώριση τομέα ανώτατης εκπαίδευσης (Πανεπιστήμιο ή ΤΕΙ) του κρινόμενου τίτλου.<br>Αντιστοιχία: Αντιστοίχιση του κρινόμενου τίτλου με συγκεκριμένο πρόγραμμα σπουδών Ελληνικού Πανεπιστημίου ή ΤΕΙ.',
    hint_consideration:'Επιλέξτε ακαδημαϊκή ισοδυναμία προς 5ετές με συνυποβολή ΜΟΝΟ εφόσον συντρέχουν τα παρακάτω: <br>(α) επιθυμείτε την ακαδημαϊκή ισοδυναμία προς πτυχία/διπλώματα, 5ετούς διάρκειας σπουδών, της ημεδαπής επιπέδου 7 του Εθνικού και Ευρωπαϊκού Πλαισίου Προσόντων <br>(β) ο τίτλος 1ου κύκλου σπουδών (βασικό πτυχίο) ΔΕΝ περιλαμβάνει διπλωματική εργασία, και <br>(γ) επιθυμείτε τη συνυποβολή τίτλου 2ου κύκλου σπουδών (μεταπτυχιακό). <br>Επισημαίνεται ότι εφόσον συνυποβληθεί τίτλος 2ου κύκλου σπουδών, ο εν λόγω τίτλος  ΔΕΝ ΔΥΝΑΤΑΙ ΝΑ ΑΝΑΓΝΩΡΙΣΘΕΙ ΑΥΤΟΤΕΛΩΣ.',
    hint_con: 'Έχετε επιλέξει να υποβάλετε:',
    hint_typeof_studies:
      'Συμβατικός: Η φοίτηση απαιτεί τη φυσική παρουσία του εκπαιδευομένου στον τόπο διδασκαλίας.<br> Εξ αποστάσεως: Ο εκπαιδευόμενος βρίσκεται σε φυσική απόσταση από τον διδάσκων και η διαδικασίας μάθησης πραγματοποιείται με χρήση σύγχρονων τεχνολογικών μέσων.',
    hint_aeitei:
      'Επιλογή τομέα ανώτατης εκπαίδευσης για Ισοτιμία/Ισοτιμία και Αντιστοιχία.',
    hint_regular_partial:
      'Τακτική: Υποχρεωτική παρακολούθηση μαθημάτων σε πλήρη βάση φοίτησης. <br>Μερική: Υποχρεωτική παρακολούθηση μαθημάτων σε μερική βάση φοίτησης, παρατείνοντας τη διάρκεια σπουδών.',
    hint_partial_gr:
      'Εάν μέρος της φοίτησης έγινε στην Ελλάδα, πρέπει να δηλωθεί η πόλη και το ίδρυμα όπου έγινε η διδασκαλία.',
    hint_other_country:
      'Επιλογή Άλλο για εισαγωγή χώρας Πανεπιστημίου που δεν υπάρχει στη λίστα. Αυτό θα επιφέρει καθυστερήσεις στη διαδικασία αναγνώρισης.',
    hint_other_university:
      'Επιλογή Άλλο για εισαγωγή Πανεπιστημίου που δεν υπάρχει στη λίστα. Αυτό θα επιφέρει καθυστερήσεις στη διαδικασία αναγνώρισης.',
    hint_title: 'Εισαγωγή του τίτλου σπουδών, όπως αναγράφεται στο πτυχίο.',
    hint_credits:
      'Οι πιστωτικές μονάδες που αποδόθηκαν στον συγκεκριμένο τίτλο σπουδών. Τυχόν μεταφερόμενες πιστ. μονάδες (από άλλα ιδρύματα ή προγράμματα σπουδών) δηλώνονται σε παρακάτω επιλογή. Εάν ο τίτλος σπουδών δεν απαιτεί πιστ. μονάδες, συμπληρώστε την τιμή 0.',
    hint_reg_date:
      'Ημερομηνία εγγραφής στο Ίδρυμα απονομής του τίτλου σπουδών.',
    hint_grad_date:
      'Ημερομηνία αποφοίτησης από το Ίδρυμα απονομής του τίτλου σπουδών.',
    hint_duration: 'Προβλεπόμενα έτη σπουδών από το εν λόγω πρόγραμμα.',
    hint_more_unis:
      'Εάν οι σπουδές έγιναν σε περισσότερα ιδρύματα ή προγράμματα σπουδών, πρέπει να αναγραφούν αναφέροντας, επίσης, και τις πιστωτικές μονάδες που μεταφέρθηκαν από αυτά. ',
    hint_correspondence_uni:
      'Επιλογή του προγράμματος σπουδών Ελληνικού Πανεπιστημίου με το οποίο θα γίνει η ακαδημαϊκή ισοδυναμία του κρινόμενου τίτλου.',
    label_attachment: 'Επιλέξτε Δικαιολογητικό',
    label_attachment2: 'και σχετικό pdf αρχείο',
    hint_attachment:
      'Επιλέξτε <b>ΕΝΑ αρχείο pdf μεγέθους μέχρι 13Mb<b> (Αν είναι μεγαλύτερου μεγέθους, χωρίστε το σε μικρότερα pdf αρχεία και ανεβάστε τα ως "ΑΛΛΟ ΕΓΓΡΑΦΟ" με σχετικό σχόλιο δίπλα)',
    hint_mandatoryfile: 'Υποχρεωτικό Έγγραφο',
    hint_mandatoryfile2: 'Υποχρεωτικό ανά περίπτωση έγγραφο',
    label_info: 'Πληροφορίες',
    personal_data: 'Προσωπικά Στοιχεία',
    wrong_credentials: 'Λάθος όνομα ή κωδικός',
    filesize:
      'Μπορείτε να ανεβάσετε αρχείο μέχρι 12Mb. Αν είναι μεγαλύτερο σπάστε το και ανεβάστε το στο "ΑΛΛΟ ΕΓΓΡΑΦΟ" με σχετική σημείωση',
    upload_fail: 'Το ανέβασμα του αρχείου απέτυχε',
    fill_in_all_fields:
      'Παρακαλώ συμπληρώστε τα πεδία και επιβεβαιώστε ότι ενημερωθήκατε σχετικά με το σύστημα του eDoatap',
    // overdue_warning: 'Η αίτηση επανεξέτασης είναι εκπρόθεσμη. Σύμφωνα με το άρθρο 13 του Ν. 3328/2005, ο πολίτης του οποίου απορρίπτεται αίτημα αναγνώρισης τίτλου σπουδών, δικαιούται να υποβάλει εντός έτους από την κοινοποίηση της απόρριψης του αιτήματός του, αίτηση για επανεξέταση του θέματος, παραθέτοντας τους λόγους επανεξέτασης και προσκομίζοντας νέα στοιχεία και το σχετικό παράβολο (225€).  Εκπρόθεσμη αίτηση επανεξέτασης κρίνεται από την Ολομέλεια του Δ.Σ. για το αν θα γίνει ή όχι αποδεκτή. Εφόσον η εκπρόθεσμη αίτηση επανεξέτασης απορριφθεί, τότε το ποσό του παραβόλου επιστρέφεται μειωμένο κατά 20€. Είστε σίγουροι ότι θέλετε να προχωρήσετε σε υποβολή;',
    overdue_warning: 'Η αίτηση επανεξέτασης είναι εκπρόθεσμη. Σύμφωνα με το άρθρο 313 του Ν.4957/2022, ο πολίτης του οποίου απορρίπτεται αίτημα αναγνώρισης τίτλου σπουδών, δικαιούται να υποβάλει εντός εξήντα (60) ημερών από τη λήψη της απόρριψης του αιτήματός του, αίτηση για επανεξέταση του θέματος, παραθέτοντας τους λόγους επανεξέτασης και προσκομίζοντας νέα στοιχεία και το σχετικό παράβολο των 150 ευρώ. Για εκπρόθεσμη αίτηση επανεξέτασης, το ποσό του παραβόλου επιστρέφεται κατόπιν σχετικής αίτησης. Είστε σίγουροι ότι θέλετε να προχωρήσετε σε υποβολή;',
    overdue_warning_final: 'Η αίτηση επανεξέτασης είναι εκπρόθεσμη. Σύμφωνα με το άρθρο 313 του Ν.4957/2022, ο πολίτης του οποίου απορρίπτεται αίτημα αναγνώρισης τίτλου σπουδών, δικαιούται να υποβάλει εντός εξήντα (60) ημερών από τη λήψη της απόρριψης του αιτήματός του, αίτηση για επανεξέταση του θέματος, παραθέτοντας τους λόγους επανεξέτασης και προσκομίζοντας νέα στοιχεία και το σχετικό παράβολο των 150 ευρώ. Για εκπρόθεσμη αίτηση επανεξέτασης, το ποσό του παραβόλου επιστρέφεται κατόπιν σχετικής αίτησης. Επίσης, η αίτησή σας θα υποβληθεί οριστικά και δεν θα έχετε δικαίωμα περαιτέρω επεξεργασίας της, εκτός αν σας ζητηθεί εκ νέου στα πλαίσια του προελέγχου της. Είστε σίγουροι ότι θέλετε να προβείτε στην οριστική υποβολή της;',
    submit_warning: 'Είστε σίγουροι ότι θέλετε να δημιουργήσετε αίτηση;',
    fill_in_personal_data_with_caps:
      'Συμπληρώστε τα Προσωπικά σας Στοιχεία με κεφαλαίους χαρακτήρες',
    title_study: 'Τίτλος Σπουδών',
    fill_in_information_title_of_study:
      'Συμπληρώστε τα απαιτούμενα στοιχεία με κεφαλαίους χαρακτήρες',
    fill_in_information_title_assesed:
      'Συμπληρώστε τα στοιχεία του συνεκτιμόμενου Τίτλου Σπουδών με κεφαλαίους χαρακτήρες',
    upload_documents: 'Μεταφορτώστε τα απαραίτητα Δικαιολογητικά',
    process: 'Εξέλιξη Αίτησης',
    app_process: 'Η εξέλιξη της αίτησης σας',
    app_status: 'ΚΑΤΑΣΤΑΣΗ ΑΙΤΗΣΗΣ',
    reappraisal_app: 'ΣΧΕΤΙΚΗ ΑΡΧΙΚΗ ΑΙΤΗΣΗ ΑΝΑΓΝΩΡΙΣΗΣ',
    post_exam_reapp_app: 'ΣΧΕΤΙΚΗ ΑΡΧΙΚΗ ΑΙΤΗΣΗ ΕΠΑΝΕΞΕΤΑΣΗΣ',
    first_reappraisal_app: 'ΑΡΧΙΚΗ ΑΙΤΗΣΗ ΕΠΑΝΕΞΕΤΑΣΗΣ',
    app_ref: 'ΑΡΙΘΜΟΣ ΚΑΤΑΧΩΡΗΣΗΣ ΑΙΤΗΣΗΣ',
    reg_no: 'ΑΡΙΘΜΟΣ ΠΡΩΤΟΚΟΛΛΟΥ',
    applicant: 'Αιτών',
    prechecking: 'Προέλεγχος',
    waiting: 'Αναμονή Ελέγχου',
    surname: 'Επώνυμο',
    name: 'Όνομα',
    fname: 'Πατρώνυμο',
    mname: 'Μητρώνυμο',
    gender: 'Φύλο',
    countryofbirth: 'Χώρα γέννησης',
    cityofbirth: 'Πόλη γέννησης',
    dateofbirth: 'Ημερ. γέννησης',
    countryofresidence: 'Χώρα διαμονής',
    homeaddress: 'Διευθ. κατοικίας',
    zip: 'Τ.Κ.',
    city: 'Πόλη',
    institution: 'Ίδρυμα',
    region: 'Περιοχή',
    tel: 'Τηλέφωνο',
    mobile: 'Κινητό',
    email: 'Email',
    afm: 'ΑΦΜ',
    idcard: 'Ταυτότητα',
    passport: 'Διαβατήριο',
    idnumber: 'Αριθμός',
    dateofissue: 'Ημερ. έκδοσης',
    depofissue: 'Εκδούσα αρχή',
    expirationdate: 'Ημερ. Λήξης',
    countryofissue: 'Χώρα έκδοσης',
    equivalenceorcorrespondence: 'Ακαδημαϊκή Ισοδυναμία',
    equivalenceorcorrespondence2: 'Ακαδημαϊκή Ισοδυναμία με συνεκτίμηση για 5ετές',
    equivalenceorcorrespondence3: 'Ακαδ. Ισοδυναμία',
    equivalenceofdegree: 'Ισοτιμία Πτυχίου',
    with: 'με ',
    uni_tei: 'Πανεπιστήμιο ή ΤΕΙ',
    department: 'Τμήμα Πανεπιστημίου',
    department2: 'Τμήμα ΤΕΙ',
    university: 'Πανεπιστήμιο',
    only: 'μόνο με ',
    tei: 'ΤΕΙ',
    titleforrec: 'Στοιχεία Τίτλου προς αναγνώριση',
    studymode: 'Τύπος φοίτησης',
    conventional: 'Συμβατικός',
    distance: 'Εξ αποστάσεως',
    fulltime: 'Τακτική',
    parttime: 'Μερική',
    select_country2: 'Επιλέξτε Χώρα για να δείτε τα σχετικά Πανεπιστήμια',
    countryofstudy: 'Χώρα Σπουδών',
    titleofstudy: 'Τίτλος Σπουδών',
    ects: 'Πιστ. μονάδες (credits)',
    credits: 'Μονάδες',
    enroll_date: 'Ημ/νια έναρξης προγ.',
    grad_date: 'Ημ/νια απονομής τίτλου',
    duration: 'Διάρκεια Σπουδών',
    study_madein: 'Οι σπουδές έγιναν',
    joint_assess: 'Αναγνώριση Τίτλου',
    coevaluation: 'Συνυποβολή',
    coevaluation_check: 'You have chosen co-submission of a 2nd cycle degree',
    select_doctype: 'Επιλέξτε Δικαιολογητικό',
    select_file: 'Επιλογή αρχείου',
    hint_more_unis2:
      'Συμπληρώστε τα επιπλέον Πανεπιστήμια και τις πιστωτικές μονάδες',
    add_university: 'Προσθήκη Πανεπιστημίου',
    delete_university: 'Διαγραφή Πανεπιστημίου',
    ido: 'Επιθυμώ',
    docs_instructions: 'Έντυπα και Οδηγίες',
    docs_link: 'Δικαιολογητικά',
    prechecker_comment: 'Σχόλιο Προελέγχου',
    applicant_comment: 'Σχόλια Αιτούντα',
    about: 'Για την εφαρμογή',
    report: 'αναφέρετε προβλήματα-παρατηρήσεις',
    temp_save: 'Προσωρινή Αποθήκευση',
    final_save: 'Οριστική Υποβολή',
    submission: 'Υποβολή',
    placeholder: 'Παρακαλώ πληκτρολογήστε το κείμενό σας',
    retract_app: 'Επαναεπεξεργασία Αίτησης',
    delete_app: 'Διαγραφή Αίτησης',
    new_search: 'Αναζήτηση - Νέα Αίτηση',
    options: 'Επιλογές',
    select_type: 'Επιλέξτε Τύπο',
    view: 'Προβολή',
    logout: 'Αποσύνδεση',
    type_of_app: 'Τύποι Αιτήσεων',
    select: 'Επιλέξτε',
    myApps: 'Οι αιτήσεις μου',
    newApp: 'Νέα Αίτηση',
    applicationType: 'Τύπος Αίτησης',
    recognition: 'Αναγνώριση Τίτλου',
    reappraisal: 'Αίτηση Επανεξέτασης',
    compensatory: 'Έκδοσης πράξης μετά από εξετάσεις',
    rec_institution: 'Εξέτασης Ομοταγούς Ιδρύματος Εξωτερικού',
    level_of_study: 'Επίπεδο Σπουδών',
    myfinalizedApps: 'Ολοκληρωμένες',
    phd: 'Τίτλος 3ου κύκλου σπουδών',
    master: 'Τίτλος 2ου κύκλου σπουδών',
    bachelor: 'Τίτλος 1ου κύκλου σπουδών',
    correspondence: 'Ισοδυναμία με συνεκτίμηση για 5ετές',
    equality: 'Ισοδυναμία',
    yes: 'Ακαδ.ισοδυναμία προς 5ετές με συνυποβολή',
    no: 'Ακαδ. ισοδυναμία',
    submit: 'Επιβεβαίωση',
    force_overdue: 'Σήμανση ως "εκπρόθεσμη" (μόνο σε δοκιμαστικό περιβάλλον)',
    force_overdue_hint: 'Η επιλογή αυτή είναι διαθέσιμη <b>μόνο</b> σε δοκιμαστικό περιβάλλον<br>για την υποχρεωτική σήμανση της αίτησης ως εκπρόθεσμης<br>κατά την <b>πρώτη</b> "Οριστική Υποβολή"',
    overdue_message: 'ΠΡΟΣΟΧΗ! Η αίτηση επανεξέτασης είναι εκπρόθεσμη',
    app_status1: 'Κατάσταση αίτησης',
    date: 'Ημερομηνία',
    document: 'Δικαιολογητικό',
    filename: 'Όνομα Αρχείου',
    actions: 'Ενέργειες',
    user_comment: 'Σχόλιο Χρήστη',
    doatap_comment: 'Σχόλιο ΔΟΑΤΑΠ',
    new_app_title: 'Παρακαλώ επιλέξτε τον τύπο της αίτησής σας',
    president: 'Πρόεδρος',
    proponent: 'Χειριστής',
    executive: 'Εκτελεστική Επιτροπή (ν. 3328/05)',
    consultant: 'Αξιολογητής',
    viceA: 'Αντιπρόεδρος A (ν. 3328/05)',
    viceB: 'Αντιπρόεδρος B (ν. 3328/05)',
    process_viewer: 'Διοικητικός Έλεγχος',
    print: 'Σύνταξη Απόφασης',
    reappraisal_board: 'Ειδική Επιτροπή Επανεξέτασης',
    academic_director: 'Δ/ντής Ακαδ. Αναγνώρισης',
    completed1: 'Ολοκληρωμένη - Η αίτηση ακυρώθηκε κατόπιν αιτήματος πολίτη',
    completed2: 'Ολοκληρωμένη',
    registered_app: 'Πρωτοκολλημένη - Υπό Διαδικασία Αναγνώρισης',
    registered_reapp: 'Πρωτοκολλημένη - Υπό Διαδικασία Επανεξέτασης',
    registered_post_exam: 'Πρωτοκολλημένη - Υπό διαδικασία έκδοσης πράξης μετά από εξετάσεις',
    temp_saved: 'Προσωρινά Αποθηκευμένη - Μη Υποβληθείσα',
    final_saved: 'Υποβληθείσα - Υπό Διαδικασία Προελέγχου',
    date_received: 'Ημερομηνία αποστολής ενημέρωσης για παραλαβή απόφασης',
    date_downloaded: 'Ημερομηνία παραλαβής της απόφασης',
    date_done: 'Ημερομηνία Απόφασης',
    decision_no: 'Αριθμός Πράξης',
    one_university: 'σε ένα Πανεπιστήμιο',
    several_universities: 'σε περισσότερα Πανεπιστήμια',
    conclusion: 'Αίτηση Αναγνώρισης ',
    conclusion2: ' για τίτλο 1ου κύκλου σπουδών',
    conclusion3: ' για ακαδημαϊκή ισοδυναμία',
    conclusion4:
      ' για ακαδημαϊκή ισοδυναμία',
    conclusion5: ' με Πανεπιστήμιο ή ΤΕΙ',
    conclusion6: ' MONO με Πανεπιστήμιο',
    conclusion7: ' MONO με ΤΕΙ',
    conclusion8: ' προς πτυχίο / δίπλωμα, 5ετούς διάρκειας σπουδών, της ημεδαπής επιπέδου 7 του Εθνικού και Ευρωπαϊκού Πλαισίου Προσόντων με συνυποβολή τίτλου 2ου κύκλου σπουδών (μεταπτυχιακό)',
    conclusion9: ' για τίτλο 2ου κύκλου σπουδών',
    conclusion12: ' για τίτλο 3ου κύκλου σπουδών',
    conclusion13: 'Αίτηση επανεξέτασης',
    titleTemp0:
      'Ο χρήστης ετοιμάζει την αίτηση του πριν την υποβάλει οριστικά για επεξεργασία',
    contentTemp0: 'Επεξεργασία από τον χρήστη',
    titleTemp1:
      'Η αίτηση βρίσκεται στην ουρά προελέγχου όπου θα διαπιστωθεί η πληρότητα των στοιχείων και των δικαιολογητικών',
    contentTemp1: 'Αναμονή για έλεγχο στοιχείων',
    titleTemp2: 'Αναμένεται',
    titleTemp21: 'Σε επεξεργασία από υπάλληλο προελέγχου',
    titleTemp22: 'Επεξεργασία Προελέγχου',
    titleTemp2postExam: 'Επεξεργασία Προελέγχου (μετά από Εξετάσεις)',
    contentTemp2: 'Επεξεργασία από υπάλληλο προελέγχου',
    contentTemp2postExam: 'Επεξεργασία από υπάλληλο προελέγχου (μετά από Εξετάσεις)',
    titleTemp3: 'Αναμονή δρομολόγησης από Πρόεδρο',
    titleTemp33: 'Επεξεργασία από τον Πρόεδρο',
    titleTemp32: 'Υπογραφή και έκδοση απόφασης',
    titleTemp34:
      'Tο αρχείο της απόφασης βρίσκεται στα επισυναπτόμενα από όπου και μπορείτε να το κατεβάσετε',
    contentTemp34: 'Ολοκλήρωση αναγνώρισης',
    contentTemp35: 'Παραλαβή πράξης',
    titleTemp4: 'Αποτέλεσμα επεξεργασίας Χειριστή',
    titleTemp41: 'Επεξεργασία από τον Χειριστή',
    titleTemp5: 'Επεξεργασία από την Εκτελεστική Επιτροπή',
    titleTemp6: 'Επεξεργασία από τον Αξιολογητή',
    titleTemp7: 'Επεξεργασία από τον Αντιπρόεδρο',
    titleTemp9: 'Προεργασία για την αποστολή στον Πρόεδρο',
    titleTemp10: 'Καθαρογράψιμο της απόφασης',
    titleTemp11: 'Επεξεργασία από την Ειδική Επιτροπή Επανεξέτασης',
    titleTemp12: 'Επεξεργασία από τον Δ/ντή Ακαδ. Αναγνώρισης',
    historyTitleDownloaded: 'Η απόφαση παραλήφθηκε από τον αιτούντα',
    historyContentDownloaded: 'Λήψη απόφασης',
    historyTitlePrintDecisionsQueue: 'Στη σειρά για καθαρογράψιμο απόφασης',
    historyContentPrintDecisionsQueue: 'Στη σειρά για καθαρογράψιμο απόφασης',
    historyTitlePrintDecision: 'Στη σειρά για καταχώρηση απόφασης',
    historyContentPrintDecision: 'Στη σειρά για καταχώρηση απόφασης',
    with_equivalence: 'με Ακαδημαϊκή Ισοδυναμία',
    without_equivalence: 'με Ακαδημαϊκή Ισοδυναμία',
    with_consideration: 'προς 5ετές με συνυποβολή',
    without_consideration: 'χωρίς Συνεκτίμηση Μεταπτυχιακού',
    for: 'για',
    for_app: 'για την αίτηση',
    informed: 'Ενημερώθηκα',
    consent: 'Συναινώ',
    download: 'Λήψη',
    delete: 'Διαγραφή',
    attachments: 'Επισυναπτόμενα',
    warning: 'Προειδοποίηση',
    error: 'Σφάλμα',
    cancel: 'Άκυρο',
    button_yes: 'Ναι',
    //     delete_fail:'Η διαγραφή δεν έγινε',
    refresh_notallowed:
      'Δεν επιτρέπεται η ανανέωση γιατί ενδέχεται να οδηγήσει σε απώλεια δεδομένων! Για να βγείτε από την εφαρμογή και να διαγραφούν τα προσωρινά δεδομένα από τον φυλλομετρητή σας παρακαλώ πατήστε αποσύνδεση πάνω δεξιά.',
    msg_forDB:
      'Η βάση δεδομένων του οργανισμού διατηρεί στοιχεία πράξεων αναγνώρισης τίτλων από το 1998 και μετά',
    fill_comment: 'Παρακαλώ συμπληρώστε ένα σχόλιο',
    success: 'Επιτυχία',
    //     success_delete:'Η διαγραφή πραγματοποιήθηκε',
    fail: 'Αποτυχία',
    fail_delete: 'Η διαγραφή δεν πραγματοποιήθηκε',
    //     data_saved:'Τα δεδομένα αποθηκεύτηκαν με επιτυχία',
    submitApp:
      'Η αίτησή σας θα υποβληθεί οριστικά και δεν θα έχετε δικαίωμα περαιτέρω επεξεργασίας της, εκτός αν σας ζητηθεί εκ νέου στα πλαίσια του προελέγχου της. Είστε σίγουροι ότι θέλετε να προβείτε στην οριστική υποβολή της;',
    failed_submit: 'Η οριστική υποβολή δεν είναι δυνατή!',
    failed_submit2: 'Η αίτηση έχει ελλείψεις στις εξής Καρτέλες:',
    failed_submit3: ' Προσωπικά Στοιχεία,',
    failed_submit4: ' Τίτλος Σπουδών,',
    failed_submit5: ' Συνυποβολή Τίτλου,',
    failed_submit6:
      ' Επισυναπτόμενα όπου πρέπει να προστεθούν όλα τα υποχρεωτικά ',
    //     msg_finalsave:'Η αίτηση αποθηκεύτηκε οριστικά. Θα περιμένετε ενημέρωση μέσω email για την εξέλιξη της που μπορείτε να παρακολουθείτε από την καρτέλα Εξέλιξη Αίτησης',
    protocol_expected: 'Αναμένεται μετά την οριστική υποβολή της αίτησης',
    //     comment_saved:'Το σχόλιο σας στάλθηκε',
    fill_in: 'Πρέπει να συμπληρώσετε όλα τα πεδία!',
    fill_confirm: 'Πρέπει να συμπληρώσετε τα κατάλληλα πεδία, να δηλώσετε ότι λάβατε γνώση των παραπάνω όρων, τη συναίνεσή σας στη Δήλωση Προστασίας Προσωπικών Δεδομένων καθώς και να δηλώσετε υπεύθυνα τη γνησιότητα των πιστοποιητικών που θα υποβάλλετε. ',
    same_pass_msg: 'Πρέπει να βάλετε τον ίδιο κωδικό για επιβεβαίωση!',
    session_expire_msg:
      'Η συνεδρία σας θα λήξει σε ένα λεπτό παρακαλώ πατήστε προσωρινή αποθήκευση γιατί θα χρειαστεί να επανασυνδεθείτε για λόγους ασφαλείας',
    no_unis_found: 'Δεν βρέθηκαν Πανεπιστήμια για την συγκεκριμένη Χώρα',
    correct_approval:
      'Αν επιλέξετε Διόρθωση στοιχείων πρέπει να καταγράψετε τον λόγο υποχρεωτικά!',
    //     approval:'Η έγκριση σας αποθηκεύτηκε οριστικά και προωθείται για υπογραφή. Θα περιμένετε ενημέρωση μέσω email για την εξέλιξή της που μπορείτε να παρακολουθείτε από το tab Εξέλιξη Αίτησης',
    //     approval_fail:'Η αποστολή της έγκρισης απέτυχε',
    change_pass:
      'Αν γίνει επιτυχής αλλαγή Θα δρομολογηθείτε για επανασύνδεση στο e-doatap με τους νέους σας κωδικούς',
    confirm_retract: 'Η αίτηση σας θα ανοίξει ξανά για επεξεργασία',
    confirm_delete: 'Αυτό θα Διαγράψει οριστικά την αίτηση σας',
    //     app_deleted:'Η αίτηση διαγράφηκε',
    retract_canceled: 'Η επιλογή για επανεπεξεργασία ακυρώθηκε',
    delete_canceled: 'Η διαγραφή ματαιώθηκε',
    add_info:
      'Πατώντας στην κάθε γραμμή χρόνου, εμφανίζονται οι επιπλέον πληροφορίες κάτω από το γράφημα',
    select_university: 'Επιλέξτε Πανεπιστήμιο',
    search: 'Αναζητήστε',
    doc: 'Δικαιολογητικό',
    comments: 'Σχόλια',
    overall_comment: 'Συνολικό σχόλιο για την αίτηση',
    hint_tempsave:
      'Αποθηκεύει προσωρινά την Αίτηση κατά την διάρκεια δημιουργίας της',
    hint_finalsave:
      'Ολοκληρώνει την διαδικασία υποβολής μιας Αίτησης. Δεν μπορούν να γίνουν νέες αλλαγές στην Αίτηση',
    hint_retract:
      'Επαναφέρει την αίτηση σας ΜΟΝΟ όταν είναι στην ουρά προελέγχου για περαιτέρω επεξεργασία',
    hint_delete:
      'Διαγράφει οριστικά την Αίτηση σας. Διαθέσιμη μόνο πρίν την Οριστική Υποβολή της Αίτησης',
    select_country: 'Επιλέξτε Χώρα',
    select_date: 'Επιλέξτε Ημερομην.',
    country: 'Χώρα',
    placeholder_act: 'Παρατηρήσεις για πράξη (έως 300 χαρακτήρες)',
    fill_in_country: 'Συμπληρώστε την Χώρα',
    fill_in_uni: 'Συμπληρώστε το Πανεπιστήμιο σας',
    universities: 'Πανεπιστήμια',
    years: 'Έτη',
    new_university: 'Νέο Πανεπιστήμιο',
    greek_uni: 'Ελληνικό Πανεπιστήμιο',
    foreign_uni: 'Πανεπιστήμιο του εξωτερικού',
    first_bachelor: 'Τίτλος 1ου κύκλου σπουδών ',
    firstBachelorInfoMsg: 'Συμπληρώστε τα στοιχεία του βασικού σας πτυχίου (τίτλου 1ου κύκλου σπουδών)',
    dep_uni: 'Τμήμα/Πανεπιστήμιο',
    rec_act: 'Πράξη αναγνώρισης',
    male: 'ΑΝΔΡΑΣ',
    female: 'ΓΥΝΑΙΚΑ',
    other_gender: 'ΑΛΛΟ',
    other_option: 'Άλλο',
    other_country: 'Άλλη Χώρα',
    finalsave_canceled: 'Η Οριστική Αποθήκευση ματαιώθηκε.',
    draft_approval:
      'Παρακαλώ αφού εξετάσετε προσεκτικά το προσχέδιο της πράξης, επικαιροποιήστε τα αναγραφόμενα στοιχεία σας και πατήστε αποστολή. Εάν χρειάζεται διόρθωση στοιχείων, παρακαλώ συμπληρώστε τις παρατηρήσεις σας στο αντίστοιχο πεδίο. Εάν δεν αποστείλετε την επικαιροποίηση εντός 5 ημερών από την έκδοση του προσχεδίου, η πράξη θα εκδοθεί ως έχει.',
    updateData: 'Επικαιροποίηση',
    correctInfo: 'Ορθά Στοιχεία',
    updateInfo: 'Διόρθωση στοιχείων',
    remarks: 'Παρατηρήσεις',
    sendApprove: 'Αποστέλει την έγκριση με τα σχόλια σας.',
    sendApprove2: 'Αποστολή Επικαιροποίησης',
    first_download:
      'Η χρονική στιγμή που θα κατεβάσετε το αρχείο για πρώτη φορά θεωρείται ημερομηνία παραλαβής της πράξης. Σε περίπτωση που δεν μπορείτε να ανοίξετε το αρχείο, πρέπει να επικοινωνήσετε εντός ΔΕΚΑ (10) ημερών με το ΔΟΑΤΑΠ',
    first_download2:
      'Η χρονική στιγμή που θα κατεβάσετε το αρχείο για πρώτη φορά (πατώντας το κουμπί ΟΚ) θεωρείται ημερομηνία παραλαβής της απόφασης.',
    remaining:
      'ημέρες απομένουν να επικοινωνήσετε με το ΔΟΑΤΑΠ αν υπάρχει κάποιο πρόβλημα.',
    received: 'Παραλάβατε την πράξη αναγνώρισης ',
    daysbefore: ' ημέρες πριν',
    attention:
      `ΠΡΟΣΟΧΗ, έχετε επιλέξει ακαδημαϊκή ισοδυναμία προς 5ετές με συνυποβολή. Η επιλογή αυτή είναι δυνατή ΜΟΝΟ εφόσον συντρέχουν τα παρακάτω: 
        (α) επιθυμείτε την ακαδημαϊκή ισοδυναμία προς πτυχία /διπλώματα, 5ετούς διάρκειας σπουδών, της ημεδαπής επιπέδου 7 του Εθνικού και Ευρωπαϊκού Πλαισίου Προσόντων 
        (β) ο τίτλος 1ου κύκλου σπουδών (Βασικό πτυχίο) ΔΕΝ περιλαμβάνει διπλωματική εργασία, και 
        (γ) επιθυμείτε τη συνυποβολή τίτλου 2ου κύκλου σπουδών (μεταπτυχιακό). 
      Επισημαίνεται ότι εφόσον συνυποβληθεί τίτλος 2ου κύκλου σπουδών, ο εν λόγω τίτλος  ΔΕΝ ΔΥΝΑΤΑΙ ΝΑ ΑΝΑΓΝΩΡΙΣΘΕΙ ΑΥΤΟΤΕΛΩΣ.`,
    login: 'Είσοδος στο e-Doatap',
    username: 'Όνομα',
    password: 'Κωδικός',
    erase: 'Σβήσιμο',
    changepass: 'Αλλαγή Ονόματος και Κωδικού Πρόσβασης',
    newusername: 'Νέο Όνομα',
    oldpass: 'Παλιός Κωδικός',
    newpass: 'Νέος Κωδικός',
    verify: 'Επαλήθευση Νέου Κωδικού',
    session:
      'Η συνεδρία σας θα λήξει σε ένα λεπτό παρακαλώ πατήστε προσωρινή αποθήκευση γιατί θα χρειαστεί να επανασυνδεθείτε για λόγους ασφαλείας',
    newWord: 'νέα',
    my_chats: 'Οι Συνομιλίες μου',
    notifications: 'Συνομιλίες-Μηνύματα',
    application: 'Αίτηση',
    user: 'Χρήστης',
    send: 'Αποστολή',
    finalizedAppsMsg: 'Δεν βρέθηκαν ολοκληρωμένες αιτήσεις σας ώστε να μπορείτε να αιτηθείτε επανεξέτασης',
    // PersonalDetails.vue messages
    telephoneRequiredMsg: 'Παρακαλώ εισάγετε αριθμό τηλεφώνου',
    mobileValidationMsg: 'Το κινητό πρέπει να αποτελείται από 10 μέχρι 20 ψηφία',
    surnameRequiredMsg: 'Το επώνυμο δεν μπορεί να είναι κενό',
    nameRequiredMsg: 'Το όνομα δεν μπορεί να είναι κενό',
    birthDateRequiredMsg: 'Παρακαλώ συμπληρωστε την ημερομηνία γέννησης',
    fatherNameRequiredMsg: 'Το πατρώνυμο δεν μπορεί να είναι κενό',
    emailRequiredMsg: 'Εισάγετε το e-mail σας',
    emailValidationMsg: 'Παρακαλώ εισάγετε την σωστή διεύθυνση e-mail',
    mobileRequiredMsg: 'Παρακαλώ εισάγετε αριθμό κινητού',
    numberValidationMsg: 'Ο αριθμός πρέπει να αποτελείται απο 10 μέχρι 20 ψηφία',
    cityRequiredMsg: 'Παρακαλώ συμπληρώστε την πόλη',
    zipCodeValidationMsg: 'Παρακαλώ συμπληρώστε τον Τ.Κ. με 2-16 ψηφία',
    addressRequiredMsg: 'Παρακαλώ συμπληρώστε τη διευθυνσή σας',
    birthCountryRequiredMsg: 'Παρακαλώ συμπληρώστε την Χώρα Γέννησης',
    residenceCountryRequiredMsg: 'Παρακαλώ συμπληρώστε την Χώρα Διαμονής',
    genderRequiredMsg: 'Παρακαλώ συμπληρώστε το Φύλο σας',
    idNumberRequiredMsg: 'Παρακαλώ εισάγετε αριθμό',
    issueDateRequiredMsg: 'Παρακαλώ εισάγετε ημερομηνία έκδοσης',
    issueAuthorityRequiredMsg: 'Παρακαλώ εισάγετε Αρχή έκδοσης',
    expirationDateRequiredMsg: 'Παρακαλώ εισάγετε ημερομηνία λήξης',
    // TitleConsideration.vue messages
    studyCityRequiredMsg: 'Παρακαλώ εισάγετε την Πόλη που πραγματοποιήθηκαν οι σπουδές',
    institutionRequiredMsg: 'Παρακαλώ εισάγετε το Ίδρυμα που πραγματοποιήθηκαν οι σπουδές',
    studyCountryRequiredMsg: 'Παρακαλώ εισάγετε τη Χώρα σπουδών',
    universityRequiredMsg: 'Παρακαλώ εισάγετε το Πανεπιστήμιο που πραγματοποιήθηκαν οι σπουδές',
    titleRequiredMsg: 'Παρακαλώ εισάγετε τον τίτλο σπουδών',
    ectsValidationMsg: 'Παρακαλώ συμπληρώστε τις πιστωτικές μονάδες με τιμές 1 έως 1000',
    startDateRequiredMsg: 'Παρακαλώ συμπληρώστε την ημερομηνία εγγραφής',
    graduationDateRequiredMsg: 'Παρακαλώ συμπληρώστε την ημερομηνία αποφοίτησης',
    durationRequiredMsg: 'Παρακαλώ συμπληρώστε την διάρκεια σπουδών',
    // Titles.vue messages
    studyCitySelectMsg: 'Παρακαλώ εισάγετε την Πόλη που πραγματοποιήθηκαν οι σπουδές',
    institutionSelectMsg: 'Παρακαλώ εισάγετε τo ίδρυμα που πραγματοποιήθηκαν οι σπουδές',
    studyCountrySelectMsg: 'Παρακαλώ επιλέξτε τη Χώρα που πραγματοποιήθηκαν οι σπουδες',
    studyCountryInsertMsg: 'Παρακαλώ συμπληρώστε την Χώρα που πραγματοποιήθηκαν οι σπουδες',
    universitySelectMsg: 'Παρακαλώ επιλέξτε τo Πανεπιστήμιο που πραγματοποιήθηκαν οι σπουδες',
    universityInsertMsg: 'Παρακαλώ συμπληρώστε τo Πανεπιστήμιο που πραγματοποιήθηκαν οι σπουδες',
    titleInsertMsg: 'Παρακαλώ συμπληρώστε τον τίτλο σπουδών',
    ectsInsertMsg: 'Παρακαλώ συμπληρώστε τις πιστωτικές μονάδες με αριθμό από 0 μέχρι 1000',
    startDateSelectMsg: 'Παρακαλώ επιλέξτε την ημερομηνία εγγραφής',
    graduationDateSelectMsg: 'Παρακαλώ επιλέξτε την ημερομηνία αποφοίτησης',
    durationSelectMsg: 'Παρακαλώ επιλέξτε τη διάρκεια των σπουδών',
    departmentSelectMsg: 'Παρακαλώ επιλέξτε το τμήμα Πανεπιστημίου για αντιστοιχία',
    fieldRequiredMsg: 'Παρακαλώ συμπληρώστε το πεδίο',
    ...elLocale, // Or use `Object.assign({ message: '你好' }, zhLocale)`
  },
}
